import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ErrorBoundary } from './components/ui'
import './styles/index.css'
// TODO #39: self-hosted typefaces (Fontsource variable fonts). Loading the
// variable .woff2 here resolves the `'Inter'` + `'JetBrains Mono'`
// font-family references in CSS without external CDN requests, which kills
// the CSP style-src violation we had against fonts.googleapis.com.
import '@fontsource-variable/inter'
import '@fontsource-variable/jetbrains-mono'

// Top-level error boundary for catastrophic errors (SAT-96)
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary level="page">
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
